import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { TransactionsService } from '../transactions.service';
import * as transactionsActions from './txn.actions'

@Injectable({
  providedIn: 'root'
})

export class TransactionsEffects {
  constructor(
    private actions$: Actions,
    private transactionsService: TransactionsService,
    private toastr: ToastrService,
    private miscService: MiscService
  ) { }

  fetchTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.fetchTransactions),
      exhaustMap((action) =>
        this.transactionsService
          // .getMTBCardTransactions(action.timestamp)
          .getNonCardTransactions(action.timestamp, action.startDate, action.endDate)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.fetchTransactionsSuccess({ transactions: response.data }),
              // transactionsActions.fetchTransactionsSuccess({ transactions:  !response.data[0]['_id']? []: response.data}),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.fetchTransactionsFailed())
            }
            )
          )
      )
    )
  );

  createMoveToBankRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.createMoveToBankRequest),
      exhaustMap((action) =>
        this.transactionsService
          .createMoveToBankRequest(action.moveToBankRequestDto)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.createMoveToBankRequestSuccess({ processId: response.data.process_id }),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.createMoveToBankRequestFailed())
            }
            )
          )
      )
    )
  );
  moveToBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.moveToBank),
      exhaustMap((action) =>
        this.transactionsService
          .moveToBank(action.moveToBankDto)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.moveToBankSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.moveToBankFailed())
            }
            )
          )
      )
    )
  );


  fetchDebit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.fetchDebit),
      exhaustMap((action) =>
        this.transactionsService
          .fetchDebit(action.productId)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.fetchDebitSuccess({ debitDetails: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.fetchDebitFailed())
            }
            )
          )
      )
    )
  );


  checkSignatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.checkSignatures),
      exhaustMap((action) =>
        this.transactionsService
          .checkSignatures(action.paymentId)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.checkSignaturesSuccess({ signaturesResult: response }),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.checkSignaturesFailed())
            }
            )
          )
      )
    )
  );

  notifyAuthorizers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(transactionsActions.notifyAuthorizers),
      exhaustMap((action) =>
        this.transactionsService
          .notifyAuthorizers(action.notifyDto)
          .pipe(
            exhaustMap((response: any) => [
              transactionsActions.notifyAuthorizersSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(transactionsActions.notifyAuthorizersFailed({ error: error }))
            }
            )
          )
      )
    )
  );





}